<i18n lang="yaml" locale="en">
  add slide: Add slide
  slide name: Slide name
  enter slide name: Please enter slide name.
  soft limit slides reached: The recommenden number of slides ({limit}) is exceeded...
</i18n>

<i18n lang="yaml" locale="de">
  soft limit slides reached: Die empfohlene Anzahl an Seiten ({limit}) ist überschritten...
  add slide: Seite hinzufügen
  slide name: Seitennamen
  enter slide name: Bitte geben Sie den Seitennamen an.
</i18n>

<template>
  <draggable
    :options="{ handle: '.move-handle', ghostClass: 'drop-placeholder' }"
    @change="onChange"
    :list="$store.getters.children"
  >
    <slot />
    <transition
      name="fade"
      slot="footer"
    >
      <tw-button
        icon="add-circle"
        color="main"
        @click="openNewSlidePrompt"
        class="editor"
      >
        {{ $t('add slide' ) }}
      </tw-button>
    </transition>
  </draggable>
</template>

<script>
import draggable from '@/components/editor/draggable'
import TwButton from '@/components/ui/TwButton'
import { Prompt, Warning } from '@/plugins/snotify'
import softLimits from '@/projectSoftLimits'

export default {
  name: 'SliderEditor',
  components: {
    draggable,
    TwButton
  },
  methods: {
    openNewSlidePrompt () {
      new Prompt(
        this.$t('slide name'),
        this.$t('enter slide name'),
        this.addSlide).open()
    },
    addSlide (newSlideName) {
      this.$store.dispatch('addChild', {
        childType: 'slide',
        props: {
          title: newSlideName
        }
      }).then(() => {
        if (this.$store.getters.numChildren > softLimits.slides) {
          new Warning('soft limit slides reached', { limit: softLimits.slides }).open()
        }
      })
    },
    onChange (event) {
      this.$store.dispatch('moveChild', {
        name: event.moved.element.getters.name,
        movement: event.moved.newIndex - event.moved.oldIndex
      })
      if (this.$parent.currentSlide === event.moved.oldIndex) {
        this.$router.push(event.moved.element.getters.path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.button {
  margin-left: 3px;
}

.menu-item {
  /deep/ &.drop-placeholder {
    background: rgba(0, 0, 0, 0.4);
    border: 1px dashed color(secondary);
  }
}
</style>
